var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArc = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_927_19584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6368 11.9586C23.7619 7.08372 15.8587 7.08372 10.9838 11.9586C6.10887 16.8335 6.10887 24.7368 10.9838 29.6117",
    stroke: "#F87B0E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8657 30.4959C12.0998 30.2618 12.2313 29.9443 12.2313 29.6133C12.2313 29.2822 12.0998 28.9647 11.8657 28.7306C11.6316 28.4965 11.3141 28.365 10.9831 28.365C10.652 28.365 10.3345 28.4965 10.1004 28.7306C9.86633 28.9647 9.73482 29.2822 9.73482 29.6133C9.73482 29.9443 9.86633 30.2618 10.1004 30.4959C10.3345 30.73 10.652 30.8615 10.9831 30.8615C11.3141 30.8615 11.6316 30.73 11.8657 30.4959ZM29.5188 12.8429C29.7529 12.6088 29.8844 12.2913 29.8844 11.9602C29.8844 11.6291 29.7529 11.3116 29.5188 11.0776C29.2847 10.8435 28.9672 10.7119 28.6362 10.7119C28.3051 10.7119 27.9876 10.8435 27.7535 11.0776C27.5194 11.3116 27.3879 11.6291 27.3879 11.9602C27.3879 12.2913 27.5194 12.6088 27.7535 12.8429C27.9876 13.077 28.3051 13.2085 28.6362 13.2085C28.9672 13.2085 29.2847 13.077 29.5188 12.8429Z",
    fill: "#2C3038",
    stroke: "#2C3038",
    strokeWidth: 1.66582,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.5205,
    y: 10.5,
    width: 5,
    height: 5,
    fill: "white",
    stroke: "#2C3038"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.52051,
    y: 27.5,
    width: 5,
    height: 5,
    fill: "white",
    stroke: "#2C3038"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_927_19584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.9847,
    height: 28.7353,
    fill: "white",
    transform: "translate(5.02051 6)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arc.7dddadce4e91c45f64e35df04cd4c093.svg";